"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = exports.fontWeights = exports.fontSizes = void 0;
var fonts = exports.fonts = {
  heading: "\"Plus Jakarta Sans\", sans-serif",
  body: "\"Plus Jakarta Sans\", sans-serif"
};
var fontSizes = exports.fontSizes = {
  '5xl': '3.5rem',
  // 56px
  '4xl': '3rem',
  // 48px
  '3xl': '2.5rem',
  // 40px
  '2xl': '2rem',
  // 32px
  xl: '1.5rem',
  // 24px
  lg: '1.25rem',
  // 20px
  md: '1.125rem',
  // 18px
  base: '1rem',
  // 16px
  sm: '0.875rem',
  // 14px
  xs: '0.75rem' // 12px
};
var fontWeights = exports.fontWeights = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};